import React from 'react';
import type { SVGProps } from 'react';

const IconLink = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" {...props}>
    <path
      d="M7.96 23.27a5.2 5.2 0 0 1-3.7-8.9l3.47-3.47a1 1 0 1 1 1.42 1.42L5.69 15.8a3.21 3.21 0 0 0 4.54 4.53l3.46-3.46a1 1 0 1 1 1.42 1.42l-3.46 3.47a5.2 5.2 0 0 1-3.7 1.52ZM17.21 15.73a1 1 0 0 1-.7-1.72l3.46-3.46a3.19 3.19 0 0 0 0-4.54 3.21 3.21 0 0 0-4.54 0l-3.46 3.46a1 1 0 1 1-1.43-1.42l3.47-3.46a5.23 5.23 0 0 1 7.38 7.38l-3.46 3.47a1 1 0 0 1-.71.29Z"
      fill="currentColor"
    />
    <path
      d="M9.86 17.17a1 1 0 0 1-.71-1.71l5.93-6a1 1 0 1 1 1.43 1.41l-5.93 6a1 1 0 0 1-.72.3Z"
      fill="currentColor"
    />
  </svg>
);

export default IconLink;
